export const ARTISTS_UPDATED_EVENT = 'artists:updated'

export function notifyArtistsUpdated() {
  window.dispatchEvent(new Event(ARTISTS_UPDATED_EVENT))
}
